// ─── TAB SCROLL ───
function scrollToSection(id, btn) {
  const el = document.getElementById(id);
  if (!el) return;

  const nav = document.getElementById('tabNav');
  const stickyBar = document.getElementById('stickyBar');

  const navHeight = nav ? nav.offsetHeight : 0;
  const stickyHeight = stickyBar ? stickyBar.offsetHeight : 0;

  const top =
    el.getBoundingClientRect().top +
    window.scrollY -
    navHeight -
    stickyHeight -
    24;

  window.scrollTo({
    top,
    behavior: 'smooth'
  });

  document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');
}

// ─── ACTIVE TAB ON SCROLL ───
const sections = [
  'product-overview',
  'specifications',
  'assembly',
  'electrical',
  'shipping'
];

const tabBtns = document.querySelectorAll('.tab-btn');

function getNavHeight() {
  const nav = document.getElementById('tabNav');
  return nav ? nav.offsetHeight : 0;
}

function getStickyHeight() {
  const stickyBar = document.getElementById('stickyBar');
  return stickyBar && stickyBar.classList.contains('show')
    ? stickyBar.offsetHeight
    : 0;
}

window.addEventListener('scroll', () => {
  const scrollY = window.scrollY + getNavHeight() + 60;
  let current = sections[0];

  sections.forEach(id => {
    const el = document.getElementById(id);
    if (el && el.offsetTop <= scrollY) {
      current = id;
    }
  });

  tabBtns.forEach((btn, i) => {
    btn.classList.toggle('active', sections[i] === current);
  });

  const bar = document.getElementById('stickyBar');
  if (bar) {
    bar.classList.toggle('show', window.scrollY > 300);
  }
}, { passive: true });

// ─── FAQ ───
function toggleFaq(btn) {
  const item = btn.parentElement;
  const wasOpen = item.classList.contains('open');

  document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));

  if (!wasOpen) {
    item.classList.add('open');
  }
}

// ─── FINAL CTA PRICE UPDATE BY VARIANT ───
function formatMoney(cents) {
  return `$${(cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })}`;
}

function getSelectedVariantId() {
  const variantInput =
    document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
    document.querySelector('input[name="id"]') ||
    document.querySelector('select[name="id"]');

  return variantInput ? String(variantInput.value) : null;
}

function updateFinalCtaPrice() {
  const finalBtn = document.getElementById('finalCtaBtn');
  if (!finalBtn || !window.blackCubeProduct) return;

  const variantId = getSelectedVariantId();
  if (!variantId) return;

  const selectedVariant = window.blackCubeProduct.variants.find(
    variant => String(variant.id) === variantId
  );

  if (!selectedVariant) return;

  finalBtn.textContent = `Add to Cart — ${formatMoney(selectedVariant.price)}`;
}

document.addEventListener('DOMContentLoaded', () => {
  updateFinalCtaPrice();

  document.querySelectorAll('.tab-btn').forEach(btn => {
    const sectionId = btn.getAttribute('data-section');
    if (!sectionId) return;

    btn.addEventListener('click', () => {
      scrollToSection(sectionId, btn);
    });
  });
});

document.addEventListener('change', () => {
  setTimeout(updateFinalCtaPrice, 100);
});

document.addEventListener('click', () => {
  setTimeout(updateFinalCtaPrice, 150);
});

document.addEventListener('variant:change', updateFinalCtaPrice);
document.addEventListener('variant-change', updateFinalCtaPrice);

setInterval(updateFinalCtaPrice, 500);